import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from '@ifit/rapport-webview';
import I18nType from '../../../shared/i18n-prop-type';
import rapportPackage from './rapport-web.json';

import Whoops from '@ifit/mp-whoops';


export const Reload = ({ image, text, buttonText, onReload, i18n }) => {
  const button = {
    text: buttonText || i18n._translate('Try Again', { context: 'Button shown when loading has failed and prompting user to try again' }),
    action: onReload,
    className: 'retry-button',
  }
  return <Whoops image={image} text={text} buttons={[button]} />;
};

Reload.propTypes = {
  /**
   * Button on click action
   */
  onReload: PropTypes.func,
  /**
   * Warning text
   */
  text: PropTypes.string,
  /**
   * Text rendered within button
   */
  buttonText: PropTypes.string,
  /**
   * Image rendered above message
   */
  image: PropTypes.string,
  /**
   * Rapport instance from HOC
   */
  i18n: I18nType,
};

export default withTranslation(rapportPackage)(Reload);
